import React from 'react'

const StorePreviousAdCard = ({ad}) => {

  console.log(ad)
  return (
    <div>StorePreviousCard</div>
  )
}

export default StorePreviousAdCard